import React, {useEffect, useState} from "react";
import * as API from "../helpers/api";
import config from "../config";
import Loading from "react-loader-spinner";
import {useLang} from "../helpers/language";
import parse from "html-react-parser";
import BlogItem from "../components/blog-item/BlogItem";
import useWindowSize from "../assets/hooks/useWindowSize";
import "../assets/css/pages/our-blog.scss";
import {Dictionary} from "../assets/js/contexts";

const Blog = ({dictionary}) => {
    const {width} = useWindowSize();
    const {lang} = useLang();
    const [isBusy, setBusy] = useState(true);
    const [blog, setBlog] = useState([]);
    const [blogPost, setBlogPost] = useState([]);

    useEffect(() =>
    {
        window.scrollTo(0, 0);
        (async () => {
            let rowBlog = await API.get(config.api.blog);
            setBlog(rowBlog);

            let rowBlogPost = await API.get(config.api.blogPost, {}, {}, true);
            setBlogPost(rowBlogPost);

            setBusy(false);
        })();
    }, [isBusy]);

    if (isBusy) 
        return <Loading type="Oval" color="#FFBE03" className="dms-loader"/>;
     else 
        return (
            <Dictionary.Provider value={dictionary}>
                <div id="our-blog">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-md-8">
                                <h1>{
                                    blog[0]?.title && blog[0].title[lang]
                                }</h1>
                                <div className="row justify-content-center">
                                    <div className="text-center col-12">
                                        {
                                        parse(blog[0]?.desc && blog[0].desc[lang])
                                    } </div>
                                </div>
                            </div>
                        </div>

                        <div className="row"
                            style={
                                {marginTop: 15}
                        }>
                            {
                            blogPost.map((item, index) => (
                                <div key={
                                        `blog-item-${index}`
                                    }
                                    className={
                                        `${
                                            index === 0 ? "col-md-8" : "col-md-4"
                                        }`
                                    }
                                    style={
                                        {marginTop: 38}
                                }>
                                    <BlogItem index={index}
                                        item={item}
                                        windowWidth={width}/>
                                </div>
                            ))
                        } </div>
                    </div>
                </div>
            </Dictionary.Provider>
        );
    
};

export default Blog;
